<template>
  <form @submit.prevent="save" method="post">
    <b-row>
      <b-col cols="11" sm="11" class="center-block">
        <b-row v-if="titulo">
          <b-col sm="12">
            <b-form-group>
              <label v-if="task.customer_id">Cuenta</label>
              <label v-if="task.debtor_id">Deudor</label>
              <b-form-input type="text" v-model="titulo" disabled="disabled"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="txtNombre">Nombre</label>
              <b-form-input type="text" id="txtNombre" v-model="task.name" :disabled="disabled"></b-form-input>

              <div v-if="errors.name" class="invalid-feedback d-block">
                <div v-for="err in errors.name" :key="err">{{ err }}</div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <b-form-group>
              <label for="cmbEstado">Estado</label>
              <b-form-select v-model="task.status_id" id="cmbEstado" :disabled="disabled">
                <template slot="first">
                  <option :value="null" disabled>-- Seleccione el estado --</option>
                </template>
                <option v-for="item in lstStatus" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-form-select>

              <div v-if="errors.status_id" class="invalid-feedback d-block">
                <div v-for="err in errors.status_id" :key="err">{{ err }}</div>
              </div>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group>
              <label for="cmbTipoActividad">Tipo actividad</label>
              <b-form-select v-model="task.type" id="cmbTipoActividad" :disabled="disabled">
                <template slot="first">
                  <option :value="null" disabled>-- Seleccione el tipo --</option>
                </template>
                <option v-for="item in lstType" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-form-select>

              <div v-if="errors.type" class="invalid-feedback d-block">
                <div v-for="err in errors.type" :key="err">{{ err }}</div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <b-form-group>
              <label for="txtFecha">Fecha</label>
              <date-picker
                id="txtFecha"
                name="date"
                v-model="task.date"
                :config="options"
                :disabled="disabled"
              ></date-picker>

              <div v-if="errors.date" class="invalid-feedback d-block">
                <div v-for="err in errors.date" :key="err">{{ err }}</div>
              </div>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group>
              <label for="cmbComercial">Asignar a</label>
              <b-form-select id="cmbComercial" v-model="task.staff_id" :disabled="disabled">
                <template slot="first">
                  <option :value="null" disabled>-- Seleccione una opción --</option>
                </template>
                <option
                  v-for="item in lstStaffs"
                  :key="item.id"
                  :value="item.id"
                >{{ item.name }} {{ item.last_name }} - {{ item.type_name }}</option>
              </b-form-select>

              <div v-if="errors.staff_id" class="invalid-feedback d-block">
                <div v-for="err in errors.staff_id" :key="err">{{ err }}</div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="txtComentario">Comentario</label>
              <b-form-textarea
                rows="4"
                id="txtComentario"
                no-resize
                v-model="task.task"
                :disabled="disabled"
              ></b-form-textarea>

              <div v-if="errors.task" class="invalid-feedback d-block">
                <div v-for="err in errors.task" :key="err">{{ err }}</div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="disabled == false">
          <b-col sm="4" class="center-block">
            <b-button
              type="submit"
              variant="success"
              class="btn-sm col-sm-12"
              :disabled="disabled"
            >Guardar</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  name: "taskAdd",
  props: [
    "_task",
    "customer_id",
    "debtor_id",
    "title",
    "private",
    "_disabled",
    "dlg",
  ],
  data: () => {
    return {
      token: localStorage.getItem("token"),
      lstStatus: [],
      lstType: [],
      lstStaffs: [],
      titulo: null,
      isEdit: false,
      disabled: false,
      dlgAct: "",
      task: {
        staff_id: null,
        customer_id: null,
        debtor_id: null,
        process_id: null, // PENDIENTE
        name: null,
        task: null,
        date: null,
        type: null,
        private: null,
        latitude: null, // PENDIENTE
        longitude: null, // PENDIENTE
        system: "N",
        status_id: null,
      },
      options: {
        // https://momentjs.com/docs/#/displaying/
        format: "DD/MM/YYYY h:mm A",
        useCurrent: true,
        showClear: true,
        showClose: true,
      },
      datos: [],
      errores: [],
      errors: {},
    };
  },
  created() {
    showLoader();

    // TOMAR LOS VALORES ENVIADOS AL COMPONENTE
    this.titulo = this.title;
    this.disabled = this._disabled === undefined ? false : this._disabled;
    this.addResult = false;
    this.isEdit = false;
    this.dlgAct = this.dlg;

    console.log("Dialogo:" + this.dlgAct);

    if (this._task) {
      this.task = this._task;
      this.isEdit = true;
      this.addResult = this.task.status_id != "13" ? true : false; // 13 : PLANIFICADA, SE ACTIVA SOLO PARA LAS ACTIVIDADES CANCELADAS O FINALIZADAS
    } else {
      this.task = {
        staff_id: null,
        customer_id: null,
        debtor_id: null,
        date: null,
        process_id: null, // PENDIENTE
        name: null,
        task: null,
        type: null,
        private: null,
        latitude: null, // PENDIENTE
        longitude: null, // PENDIENTE
        system: "N",
        status_id: null,
      };

      this.task.customer_id =
        this.customer_id === undefined ? null : this.customer_id;
      this.task.debtor_id =
        this.debtor_id === undefined ? null : this.debtor_id;
      this.task.private = this.private;
    }

    // 5: LISTADO DE ESTADO DE LAS ACTIVIDADES O TAREAS
    this.$http.get(`${this.$urlApi}parameters/5?token=${this.token}`).then(
      (response) => {
        this.lstStatus = response.data.data;
      },
      (error) => {
        console.log(error);
      }
    );

    // 6: LISTADO DE TIPOS DE ACTIVIDAD (TASK)
    // 22: LISTADO DE TIPOS DE ACTIVIDADES
    let type = this.task.debtor_id ? 22 : 6;
    this.$http.get(`${this.$urlApi}parameters/${type}?token=${this.token}`).then(
      (response) => {
        this.lstType = response.data.data;
      },
      (error) => {
        console.log(error);
      }
    );
    //LISTADO DE STAFF'S
    if(this.task.debtor_id){

      this.$http.get(`${this.$urlApi}staffs/debtor/${this.task.debtor_id}?token=${this.token}`).then(
        response => {
          this.lstStaffs = response.data.data;
        },
        error => {
          console.log(error);
        }
      );
    }else {
      this.$http
      .get(
        `${this.$urlApi}staffs/custumer/${this.task.customer_id}?token=${this.token}`
      )
      .then(
        (response) => {
          this.lstStaffs = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    }

    hideLoader();
  },
  computed: {},
  methods: {
    save() {
      if (this.isEdit) {
        this.editTask();
      } else {
        this.addTask();
      }
    },

    addTask() {
      showLoader();

      this.errors = {};

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);

      this.task.url = `${location.origin}/#/customers/view/${this.task.customer_id}`;
      this.task.user_id = auth[0].id;

      this.datos = JSON.stringify(this.task);

      this.$http
        .post(`${this.$urlApi}tasks?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          // console.log(response);

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Actividad guardada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.task.staff_id = null;
              this.task.date = null;
              this.task.name = null;
              this.task.task = null;
              this.task.type = null;
              this.task.status_id = null;

              if ($("#" + this.dlgAct).length > 0) {
                $("#" + this.dlgAct).modal("hide");
                location.reload();
              }
            }
          });
        })
        .catch((error) => {
          this.errors = error;

          // console.log(error);
          this.errores = getMsgError(error);

          if (Array.isArray(this.errores)) {
            this.errors = this.errores[0];
          }

          console.log(this.errors);
          hideLoader();
        });
    },
    editTask() {
      showLoader();

      this.errors = {};

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);

      this.task.url = `${location.origin}/#/customers/view/${this.task.customer_id}`;
      this.task.user_id = auth[0].id;

      this.datos = JSON.stringify(this.task);
      //console.log(this.datos)

      this.$http
        .put(
          `${this.$urlApi}tasks/${this.task.id}?token=${this.token}`,
          this.datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          console.log(response);

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Actividad actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.task.staff_id = null;
              this.task.date = null;
              this.task.name = null;
              this.task.task = null;
              this.task.type = null;
              this.task.status_id = null;
              if ($("#" + this.dlgAct).length > 0) {
                $("#" + this.dlgAct).modal("hide");
                location.reload();
              }
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);

          if (Array.isArray(this.errores)) {
            this.errors = this.errores[0];
          }

          console.log(error);
          // this.errores = getMsgError(error);
          hideLoader();
        });
    },
  },
};
</script>
